export default __webpack_public_path__ + "2a7139ae97c0c0073e29bc96971d7a58.png";